import { makeAutoObservable } from 'mobx'

interface TeacherType {
	id_teacher: number
	s_t_fio: string
	t_fio: string
	post: string
	id_working:number
	id_a_year:number
}

class Teacher {
	teachers: TeacherType[] = []
	teacher: TeacherType = {
		id_teacher: 0,
		s_t_fio: '',
		t_fio: '',
		post: '',
		id_working:0,
		id_a_year:0
	}

	constructor() {
		makeAutoObservable(this)
	}

	newTeachers(param: TeacherType[]) {
		this.teachers = param
	}

	newTeacher(param: TeacherType) {
		this.teacher = param
	}
}

export const teacher = new Teacher()
